import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import './StatusSwitch.scss'

const STATUS_SWITCH_TYPE = Object.freeze({
  TOGGLE: 1,
  SELECT: 2
} as const)

type StatusSwitchType = (typeof STATUS_SWITCH_TYPE)[keyof typeof STATUS_SWITCH_TYPE]

interface Props {
  enabled: boolean
  onClick?: () => void
  className?: string
  type?: StatusSwitchType
  [key: string]: any
}

function StatusSwitch({ enabled, onClick, className = undefined, type = STATUS_SWITCH_TYPE.TOGGLE, ...rest }: Props) {
  function getStatusName() {
    if (type === STATUS_SWITCH_TYPE.TOGGLE) {
      return enabled
        ? tr('PORTAL.COMPONENTS.STATUS_SWITCH.ACTIVE', 'Active')
        : tr('PORTAL.COMPONENTS.STATUS_SWITCH.INACTIVE', 'Inactive')
    }
    return enabled
      ? tr('PORTAL.COMPONENTS.STATUS_SWITCH.ENABLED', 'Enabled')
      : tr('PORTAL.COMPONENTS.STATUS_SWITCH.DISABLED', 'Disabled')
  }

  return (
    <div
      className={cn('status-switch', className, {
        active: enabled,
        clickable: typeof onClick === 'function',
        type2: type === STATUS_SWITCH_TYPE.SELECT
      })}
      onClick={onClick}
      {...rest}
    >
      <span className='ball' />
      <span>{getStatusName()}</span>
    </div>
  )
}

export default StatusSwitch
